import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectNumberData, type NumberInfoProps } from '../../core/store/map';
import { WhiteCheckIcon } from '../icons';
import { AILabel } from '../AILabel';
import * as S from './styled';
import { selectDarkMode } from '../../core/store/app';
import { useTheme } from 'styled-components';

interface NumberLocationProps {
  fixed?: boolean;
  top?: number;
  withAILabel?: boolean;
  titleKey?: string;
}

export const NumberLocation = ({
  fixed = false,
  top = 0,
  withAILabel,
  titleKey = 'number_verified',
}: NumberLocationProps) => {
  const { t } = useTranslation();
  const darkMode = useSelector(selectDarkMode);
  const theme = useTheme();
  const numberData: NumberInfoProps = useSelector(selectNumberData);
  const labelStyles = `
		position: relative;
		top: unset;
    left: unset;
		transform: none;
		border-radius: 0 0 16px 16px;
		
		&:after {
		  height: calc(100% - 1px);
		  top: 0;
		}
	`;

  return (
    <S.Wrapper $fixed={fixed} $top={top}>
      {withAILabel ? (
        <AILabel customStyles={labelStyles}>
          <S.StyledSpan $bold dangerouslySetInnerHTML={{ __html: t('number_verified_with_ai') }} />
          {numberData?.phone_number && <S.StyledSpan>{numberData?.phone_number}</S.StyledSpan>}
        </AILabel>
      ) : (
        <S.NumberLocation>
          <WhiteCheckIcon color={darkMode ? theme.custom?.primary || 'white' : 'white'} />
          <S.StyledSpan $bold>{t(titleKey)}</S.StyledSpan>
          {numberData?.phone_number && <S.StyledSpan>{numberData?.phone_number}</S.StyledSpan>}
        </S.NumberLocation>
      )}
    </S.Wrapper>
  );
};
